import React, { useState, useEffect } from 'react';
import TextInput from '../TextInput';

interface UrlProps {
    placeholder?: string,
    value?: string,
    onValueChange?: (value: string) => void,
    displayLink?: boolean
}

const UrlInput: React.FC<UrlProps> = ({ placeholder, displayLink, value, onValueChange }) => {
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const handleInputChange = (newValue: string) => {
        setInputValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    }
    return (
        <p>
            <TextInput placeholder={placeholder} value={value} onValueChange={handleInputChange}></TextInput>
            {displayLink && <a href={inputValue} target="_blank">{inputValue}</a>}

        </p>
    );
};

export default UrlInput;